import React, { useState, useEffect, useRef  } from "react";
import "./AltaHistoriaClinica.css";
import { useParams } from "react-router-dom";
import { createHistoriaClinica, getCatalogoServiciosAtencion } from "../../../../services/historiaClinica";
import { getPacienteById } from "../../../../services/pacientes";
import { getMedicoAuth, getPerfilMedico, updatePerfilMedico, validarCluesCatalogo, validarCluesServicioAmigable  } from "../../../../services/usuarios"; // esto es para cuestionario por especialidad
import { useNavigate } from "react-router-dom";
import { mapFrontendToBackend } from "../../../../services/variableMapper";
import ModalConfirmacion from "../ModalesEdicion/ModalConfirmacion";
import "../../../../utils/DropzoneArchivos.css";
import HistoriaClinicaFormCommon from "./HistoriaClinicaFormCommon";
import { toast } from "react-toastify";
import { validarEdadServicio, esEstablecimientoEspecializadoUNEME  } from "../../../../utils/validaciones/catalogos";
import ModalPerfilIncompleto from "../ModalesEdicion/ModalPerfilIncompleto";
import ModalPacienteIncompleto, { obtenerFaltantesPacienteNOM024 } from "../ModalesEdicion/ModalPacienteIncompleto";
import ModalConsultaIncompleta from "../ModalesEdicion/ModalConsultaIncompleta";
import ModalEdadPaciente, { pacienteTieneEdadPermitida, prestadorTieneEdadPermitida, } from "../ModalesEdicion/ModalEdadPaciente";
import { useVerificarPerfil } from "../../../../utils/validaciones/hooks";
import { calcularEdadEnFechaConsulta, calcularEdadMesesEnFechaConsulta,  validarFechaConsultaNoFuturo,
  validarFechaConsultaNoAntesNacimiento, } from "../../../../utils/validaciones/expediente";
import { aplicaConfirmacionDiagnostica } from "../../../../utils/validaciones/elegibilidad";
import { msgEdadPaciente, msgFechaConsultaFuturo,
  msgFechaConsultaAntesNacimiento, } from "../../../../utils/validaciones/mensajes";


 // esto es para cuestionario por especialidad
  
    const normalizaEspecialidad = (s) => {
    if (!s) return "general";
    const t = s.toString().trim().toLowerCase();
    if (t.includes("pedi")) return "pediatria";
    if (t.includes("gine")) return "ginecologia";
    if (t.includes("geri")) return "geriatria";
    return "general";
  };

  const seedConfigFromEspecialidad = (espRaw) => {
    const esp = normalizaEspecialidad(espRaw);
    return {
      historia: [
        { key: "pediatria",   enabled: false, subtitle: "" },
        { key: "ginecologia", enabled: false, subtitle: "" },
        { key: "geriatria",   enabled: false, subtitle: "" },
      ],
      extras: [],
      custom: {
          historia: {
            capture_modes: {
              heredofamiliares: "breve",
              no_patologicos: "breve",
              patologicos: "breve",
              interrogatorio: "breve",
            }
          }
        }
      };
    };
  
const valorVacioNOM = (valor) => {
  return (
    valor === undefined ||
    valor === null ||
    String(valor).trim() === "" ||
    String(valor).trim() === "-1"
  );
};

const obtenerFaltantesHistoriaNOM024 = (historia,aplicaUneme,diagnosticosSeleccionados = {},edadPaciente = null) => {
  if (!historia) return [];

  const faltantes = [];

  if (valorVacioNOM(historia.fechaConsulta)) {
    faltantes.push("Fecha y hora de la consulta");
  }

  if (valorVacioNOM(historia.servicioAtencion)) {
    faltantes.push("Servicio de atención");
  }

  if (valorVacioNOM(historia?.exploracionFisica?.signosVitales?.sistolica) || valorVacioNOM(historia?.exploracionFisica?.signosVitales?.diastolica)) {
  faltantes.push("Presión arterial (sistólica y diastólica)");
}

  if (valorVacioNOM(historia?.exploracionFisica?.peso)) {
    faltantes.push("Peso");
  }

  if (valorVacioNOM(historia?.exploracionFisica?.altura)) {
  faltantes.push("Talla");
}

  if (valorVacioNOM(historia.codigoCIEDiagnostico1)) {
    faltantes.push("Diagnóstico CIE");
  }

  if (valorVacioNOM(historia.cartillaSalud)) {
    faltantes.push("Presenta cartilla de salud");
  }

  const signosVitales = historia?.exploracionFisica?.signosVitales || {};
  const glucemia = signosVitales.glucemia;
  const resultadoObtenidoaTravesde = signosVitales.resultadoObtenidoaTravesde;

  const hayGlucemiaRegistrada =
    !valorVacioNOM(glucemia) &&
    String(glucemia).trim() !== "0";

  const origenGlucosaValido = ["1", "2"].includes(
    String(resultadoObtenidoaTravesde).trim()
  );

  if (hayGlucemiaRegistrada && !origenGlucosaValido) {
    faltantes.push("Origen del resultado de glucosa");
  }

const primeraVezAnio = historia?.primeraVezAnio;
const primeraVezUneme = historia?.primeraVezUneme;

const requierePrimeraVezUneme =
  aplicaUneme === true &&
  String(primeraVezAnio).trim() === "1";

const primeraVezUnemeValida = ["0", "1"].includes(
  String(primeraVezUneme).trim()
);

if (requierePrimeraVezUneme && !primeraVezUnemeValida) {
  faltantes.push("Primera vez en UNEME");
}

const atencionPregestacionalRT = historia?.atencionPregestacionalRT;
const riesgo = historia?.riesgo;

const requiereRiesgoPregestacional =
  String(atencionPregestacionalRT).trim() === "0" ||
  String(atencionPregestacionalRT).trim() === "1";

if (requiereRiesgoPregestacional && valorVacioNOM(riesgo)) {
  faltantes.push("Riesgos detectados en atención pregestacional");
}

const relacionTemporalEmbarazo = historia?.relacionTemporalEmbarazo;
const trimestreGestacional = historia?.trimestreGestacional;

const requiereTrimestreGestacional =
  String(relacionTemporalEmbarazo).trim() === "0" ||
  String(relacionTemporalEmbarazo).trim() === "1";

const trimestreGestacionalValido = ["1", "2", "3"].includes(
  String(trimestreGestacional).trim()
);

if (requiereTrimestreGestacional && !trimestreGestacionalValido) {
  faltantes.push("Trimestre gestacional");
}

const pruebaEDI = String(historia?.pruebaEDI ?? "").trim();
const resultadoEDI = String(historia?.resultadoEDI ?? "").trim();

const requiereResultadoEDI = pruebaEDI === "1" || pruebaEDI === "2";

if (requiereResultadoEDI && valorVacioNOM(resultadoEDI)) {
  faltantes.push("Resultado prueba EDI");
}

const edasRT = String(historia?.edasRT ?? "").trim();
const edasPlanTratamiento = String(historia?.edasPlanTratamiento ?? "").trim();
const recuperadoDeshidratacion = String(historia?.recuperadoDeshidratacion ?? "").trim();

const requiereEdasPlan = edasRT === "0" || edasRT === "1";

if (requiereEdasPlan && valorVacioNOM(edasPlanTratamiento)) {
  faltantes.push("Plan de tratamiento EDA");
}

const requiereRecuperadoDeshidratacion =
  requiereEdasPlan && (edasPlanTratamiento === "2" || edasPlanTratamiento === "3");

if (requiereRecuperadoDeshidratacion && valorVacioNOM(recuperadoDeshidratacion)) {
  faltantes.push("Recuperación de deshidratación");
}

const irasRT = String(historia?.irasRT ?? "").trim();
const irasPlanTratamiento = String(historia?.irasPlanTratamiento ?? "").trim();

const requiereIrasPlan = irasRT === "0" || irasRT === "1";

if (requiereIrasPlan && valorVacioNOM(irasPlanTratamiento)) {
  faltantes.push("Plan de tratamiento IRA");
}

[2, 3].forEach((num) => {
  const cieAbierto =
    historia[`codigoCIEDiagnostico${num}`] ||
    historia[`primeraVezDiagnostico${num}`] !== null;

  if (!cieAbierto) return;

  const primeraVez = historia[`primeraVezDiagnostico${num}`];

  if (!["0", "1"].includes(String(primeraVez ?? "").trim())) {
    faltantes.push(`Primera vez diagnóstico ${num}`);
  }

  if (
    ["0", "1"].includes(String(primeraVez ?? "").trim()) &&
    valorVacioNOM(historia[`codigoCIEDiagnostico${num}`])
  ) {
    faltantes.push(`Diagnóstico CIE ${num}`);
  }
});

[1, 2, 3].forEach((num) => {
  const dx = diagnosticosSeleccionados[num];

  const esPrimeraVez = num === 1
    ? String(historia.relacionTemporal).trim() === "0"
    : historia[`primeraVezDiagnostico${num}`] === 1;

  const apareceConfirmacion = aplicaConfirmacionDiagnostica(
    dx,
    edadPaciente,
    esPrimeraVez
  );

  if (!apareceConfirmacion) return;

  const valor = historia[`confirmacionDiagnostica${num}`];

  if (!["0", "1"].includes(String(valor ?? "").trim())) {
    faltantes.push(`Confirmación diagnóstica ${num}`);
  }
});

  return faltantes;
};


const AltaHistoriaClinica = () => {
  const navigate = useNavigate();
  const { faltantes } = useVerificarPerfil();
  const [perfil, setPerfil] = useState(null);
  const { id: pacienteId } = useParams(); // ✅ Obtenemos el id del paciente desde la URL
  const [paciente, setPaciente] = useState(null);
  const [showPacienteInfo, setShowPacienteInfo] = useState(false);
  const pacienteHeaderRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [cuestionarioConfig, setCuestionarioConfig] = useState(null); // esto es para cuestionario por especialidad
  const [medico, setMedico] = useState(null);
  const [serviciosAtencion, setServiciosAtencion] = useState([]);
  const [aplicaUneme, setAplicaUneme] = useState(false);
  const [cluesEsServicioAmigable, setCluesEsServicioAmigable] = useState(false);
  const [showGrupoEtnicoOtro, setShowGrupoEtnicoOtro] = useState(false);
  const [historia, setHistoria] = useState({
    // ===== Cabecera =====
    fechaConsulta: "",
    tipoInterrogatorio: "",
    padecimientoActual: "",
    // ===== Datos generales (core) =====
    grupo_etnico: "",
    servicioAtencion: "",
    
     // ===== Interrogatorio por aparatos y sistemas (core) =====
      sistema_cardiovascular: "",
      sistema_digestivo: "",
      sistema_endocrino: "",
      sistema_genitourinario: "",
      sistema_hematologico: "",
      sistema_musculoesqueletico: "",
      sistema_nervioso: "",
      sistema_respiratorio: "",
      piel_anexos: "",

    exploracionFisica: {
      signosVitales: {
        sistolica: "",
        diastolica: "",
        frecuenciaCardiaca: "",
        frecuenciaRespiratoria: "",
        temperatura: "",
        saturacionOxigeno: "",
        glucemia: "",
        glucosaMedida: false,
        tipoMedicion: "-1",
        resultadoObtenidoaTravesde: "-1",
        sintomaticoRespiratorioTb: "-1",
        intervencionesSMyA: "-1",
      },
      peso: "",
      altura: "",
      otros: "",
      circunferenciaCintura: "",
    },

    // IMC mostrado dentro del rubro de Exploración (pero top-level para envío)
    imc: "",
    categoria_imc: "",
    // ===== Antecedentes =====

    antecedentes: {
      heredoFamiliares: {
        madre: "",
        padre: "",
        hermanos: "",
        abuelos: "",
        otros: "",
      },
      personalesNoPatologicos: {
        Origen: "",
        ocupacion: "",
        escolaridad: "",
        religion: "",
        mascotas: "",
        viajes: "",
        alimentacion: "",
        vivienda: "",
        otros: "",
      },
      personalesPatologicos: {
        ECD: "",
        quirurgicos: "",
        traumaticos: "",
        hospitalizaciones: "",
        infectocontagiosos: "",
        alergias: "",
        transfusionales: "",
        exantematicos: "",
        alcohol: "",
        tabaco: "",
        toxicomanias: "",
        vacunacion: "",
        ginecoObstetricosAndrologicos: "",
        hemotipo: "",
        otros: "",
      }
    },
    laboratorios: [], // Inicializado como un array vacío
    laboratorios_texto: "",    // nota libre (core, va debajo de archivos)
    relacionTemporal: null,
    diagnosticos: "",
    codigoCIEDiagnostico1: "",
    codigoCIEDiagnostico2: "",
    codigoCIEDiagnostico3: "",
    primeraVezDiagnostico2: null,
    primeraVezDiagnostico3: null,
    confirmacionDiagnostica1: null,
    confirmacionDiagnostica2: null,
    confirmacionDiagnostica3: null,
    medicamentos: [],
    planTratamiento: "",
    pronostico:"",
    indicacionesAdicionales: "",
    proximaCita: "",
  });

  const [isFechaEditable, setIsFechaEditable] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [faltantesConsulta, setFaltantesConsulta] = useState([]);
  const [showConsultaIncompleta, setShowConsultaIncompleta] = useState(false);
  // Indica qué validación de edad debe mostrar el modal bloqueante:
  // - null: no mostrar modal.
  // - "paciente": el paciente supera los 120 años.
  // - "prestador": el prestador supera los 90 años.
  const [tipoEdadBloqueante, setTipoEdadBloqueante] = useState(null);
  const [diagnosticosSeleccionados, setDiagnosticosSeleccionados] = useState({1: null,2: null,3: null,});

  // ----- Rubros (8) -----
const RUBROS = [
  
  { id: "rubro-heredofam",   label: "Antecedentes heredofamiliares" },
  { id: "rubro-no-pat",      label: "Antecedentes personales no patológicos" },
  { id: "rubro-pat",         label: "Antecedentes personales patológicos" },
  { id: "rubro-consulta",    label: "Datos de la consulta" },
  { id: "rubro-aparatos",    label: "Interrogatorio por aparatos y sistemas" },
  { id: "rubro-exploracion", label: "Exploración física" },
  { id: "rubro-dx-plan",     label: "Diagnóstico, pronóstico y plan" },
  { id: "rubro-estudios",    label: "Estudios y laboratorios" },
  { id: "rubro-cuestionario-especialidad-historia", label: "Cuestionario específico" },
];

// Varios abiertos a la vez (true/false por rubro)
const [openRubros, setOpenRubros] = useState(
  RUBROS.reduce((acc, r) => ({ ...acc, [r.id]: r.id === "rubro-consulta" }), {})
);

// Toggle individual por rubro
const toggleRubro = (id) =>
  setOpenRubros((prev) => ({ ...prev, [id]: !prev[id] }));

// Expandir/Contraer todo
const allOpen = Object.values(openRubros).every(Boolean);
const handleToggleAll = () =>
  setOpenRubros((prev) =>
    Object.keys(prev).reduce((acc, k) => ({ ...acc, [k]: !allOpen }), {})
  );

// Scroll a ancla (chips sticky)
const scrollToAnchor = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const handleOcultarSugerenciaHistorica = async (campo, valor) => {
  const valorLimpio = String(valor || "").trim();

  if (!campo || !valorLimpio) return;

  const configActual =
    perfil?.config_sugerencias_historicas &&
    typeof perfil.config_sugerencias_historicas === "object"
      ? perfil.config_sugerencias_historicas
      : {};

  const configCampoActual =
    configActual?.[campo] &&
    typeof configActual[campo] === "object"
      ? configActual[campo]
      : {};

  const ocultosActuales = Array.isArray(configCampoActual.ocultos)
    ? configCampoActual.ocultos
    : [];

  const normalizar = (texto) =>
  String(texto || "")
    .trim()
    .replace(/\s+/g, " ");

  const yaOculto = ocultosActuales.some(
    (item) => normalizar(item) === normalizar(valorLimpio)
  );

  if (yaOculto) return;

  const nuevaConfig = {
    ...configActual,
    [campo]: {
      ...configCampoActual,
      ocultos: [...ocultosActuales, valorLimpio],
    },
  };

  await updatePerfilMedico({
    config_sugerencias_historicas: nuevaConfig,
  });

  setPerfil((prev) => ({
    ...(prev || {}),
    config_sugerencias_historicas: nuevaConfig,
  }));
};

  useEffect(() => {
    const fetchPaciente = async () => {
      try {
        setIsLoading(true);
        const pacienteEncontrado = await getPacienteById(pacienteId);
        
        if (!pacienteEncontrado) {
          alert("No se encontró el paciente con este ID");
          navigate("/dashboard/pacientes");
          return;
        }
        
        setPaciente(pacienteEncontrado);
        
        // Establecer la fecha actual para la consulta
        const now = new Date();
        const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                              .toISOString().slice(0, 16);
        setHistoria(prevHistoria => ({ ...prevHistoria, fechaConsulta: localISOTime }));
        
        setIsLoading(false);
      } catch (error) {
        console.error("Error al obtener datos del paciente:", error);
        alert("Error al cargar los datos del paciente");
        setIsLoading(false);
      }
    };

    if (pacienteId) {
      fetchPaciente();
    }
  }, [pacienteId, navigate]);

    useEffect(() => {
    if (!perfil?.nom024) return;
    if (!paciente?.fecha_nacimiento) return;
    if (!historia?.fechaConsulta) return;

    const edadPaciente = calcularEdadEnFechaConsulta(
      paciente.fecha_nacimiento,
      historia.fechaConsulta
    );

    if (edadPaciente > 120) {
      msgEdadPaciente();
    }
  }, [
    perfil?.nom024,
    paciente?.fecha_nacimiento,
    historia?.fechaConsulta
  ]);

  // 🟦 Restaurar borrador si existe y corresponde a este paciente
    useEffect(() => {
      const draftRaw = localStorage.getItem("salvir_draft_historia");
      if (!draftRaw) return;

      try {
        const draft = JSON.parse(draftRaw);

        if (draft.paciente_id === pacienteId && draft.historia) {
         toast.info("Se restauró un borrador temporal, revisa tu información y laboratorios antes de guardar, ya que este borrador no se conservará.")
          setHistoria((prev) => ({
            ...prev,
            ...draft.historia
          }));
          
        }
      } catch (e) {
        console.error("❌ Error restaurando borrador:", e);
      }
      // 🟦 Se borra solo DESPUÉS de restaurar
      localStorage.removeItem("salvir_draft_historia");
    }, [pacienteId]);
    

    // esto es para cuestionario por especialidad
      useEffect(() => {
        let cancelled = false;
        (async () => {
          try {
            const [m, perfilData] = await Promise.all([
              getMedicoAuth(),
              getPerfilMedico()
            ]);
            if (cancelled) return;
                setMedico(m || null);
                setPerfil(perfilData || {});

                const cluesMedico = m?.perfil?.clues || perfilData?.clues || perfilData?.perfil?.clues;

                let esServicioAmigable = false;
                if (cluesMedico) {
                  const establecimiento = await validarCluesCatalogo(cluesMedico);
                  setAplicaUneme(esEstablecimientoEspecializadoUNEME(establecimiento));
                  esServicioAmigable = await validarCluesServicioAmigable(cluesMedico);
                  setCluesEsServicioAmigable(esServicioAmigable);
                } else {
                  setAplicaUneme(false);
                  setCluesEsServicioAmigable(false);
                }

                const servicios = await getCatalogoServiciosAtencion();
              
                const serviciosFiltrados = servicios.filter(s => 
                    
                    validarEdadServicio(
                     s.CATALOG_KEY,
                     calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, historia?.fechaConsulta),
                     esServicioAmigable
                   )
                );
                setServiciosAtencion(serviciosFiltrados);

            // 1) si ya hay config en backend, úsala
            const existing = perfilData?.config_cuestionario
            if (existing && Object.keys(existing).length > 0) {
              setCuestionarioConfig(existing);
              return;
            }

            // 2) si no hay, sembramos una vez según especialidad
            const seeded = seedConfigFromEspecialidad(m?.especialidad || "");
            setCuestionarioConfig(seeded);

            // opcional: persiste para que en próximas vistas ya venga del backend
            try {
              await updatePerfilMedico({ config_cuestionario: seeded });
            } catch (persistErr) {
              console.warn("No se pudo persistir config_cuestionario (no es crítico):", persistErr);
            }
          } catch (e) {
            console.error("Error preparando config del cuestionario:", e);
            if (!cancelled) {
              // fallback mínimo para no bloquear la UI
              setCuestionarioConfig(seedConfigFromEspecialidad(""));
            }
          }
        })();
        return () => { cancelled = true; };
     }, [paciente?.fecha_nacimiento, historia?.fechaConsulta]);
    //ESTE ES PARA LA INFO DEL PACIENTE
     useEffect(() => {
        if (!showPacienteInfo) return;
        const onMouseDown = (e) => {
          if (pacienteHeaderRef.current && !pacienteHeaderRef.current.contains(e.target)) {
            setShowPacienteInfo(false);
          }
        };
        document.addEventListener("mousedown", onMouseDown);
        return () => document.removeEventListener("mousedown", onMouseDown);
      }, [showPacienteInfo]);


      const toggleFechaEditable = () => {
        setIsFechaEditable(!isFechaEditable);
      };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHistoria({ ...historia, [name]: value });
  };

  const handleNestedChange = (e, key) => {
    const { name, value } = e.target;
    setHistoria({
      ...historia,
      [key]: { ...historia[key], [name]: value },
    });
  };

  const handleDeepNestedChange = (e, parentKey, childKey) => {
    const { name, value } = e.target;
    const updatedValue = name ? value : childKey === name ? value : historia.antecedentes[parentKey][childKey];
    
    setHistoria({
      ...historia,
      antecedentes: {
        ...historia.antecedentes,
        [parentKey]: {
          ...historia.antecedentes[parentKey],
          [childKey]: updatedValue,
        },
      },
    });
  };

const handleSubmit = async (e) => {
  if (e) e.preventDefault();
  setLoadingSubmit(true);
 
          try {
        localStorage.setItem(
          "salvir_draft_historia",
          JSON.stringify({
            paciente_id: pacienteId,
            historia: historia
          })
        );
      } catch (e) {
        console.error("❌ No se pudo guardar borrador", e);
      }

  try {
    
      // 📌 Convertimos los datos antes de enviarlos
      let historiaClinicaConvertida = mapFrontendToBackend(historia, pacienteId);
      
      

      // ✅ Verificar si paciente_id está presente
      if (!pacienteId) {
          console.error("❌ Error: paciente_id no está definido.");
          alert("Error: No se encontró el ID del paciente.");
          return;
      }

      // 📌 Crear FormData
      let formData = new FormData();
      
      // 📌 Agregar paciente_id
      formData.append("paciente_id", pacienteId);

      // 📌 Agregar los demás campos de la historia clínica, excluyendo `laboratorios`
      Object.keys(historiaClinicaConvertida).forEach((key) => {
          if (key !== "laboratorios" && historiaClinicaConvertida[key] !== null && historiaClinicaConvertida[key] !== undefined) {

        if (key === "medicamentos") {
        const normalizados = (historiaClinicaConvertida[key] || []).map(m => ({
            nombre: m?.nombre || "",
            indicaciones: m?.indicaciones || "",
            // esto se pone solo por si en un futuro lo atamos...
            vademecum_id: m?.vademecum_id ?? null
        }));
        formData.append("medicamentos", JSON.stringify(normalizados));
        } else {
            formData.append(key, historiaClinicaConvertida[key]);
        }
    }
      });
    
       //📌 Agregar archivos si existen (FLUJO VIEJO)
      //if (uploadedFiles.length > 0) {
      //    uploadedFiles.forEach((file) => {
      //      
      //        formData.append("upload_laboratorios", file);
      //    });
      //} else { 
      //}

      // 📌 Verificar los datos en FormData antes de enviarlos
     
      for (let pair of formData.entries()) {    
      }
      
      // 📌 Enviar la solicitud
      const response = await createHistoriaClinica(formData, uploadedFiles);
      
     

      alert("Historia clínica registrada correctamente");
      localStorage.removeItem("salvir_draft_historia");
      navigate("/dashboard/historias-clinicas");

  } catch (error) {
      console.error("❌ Error procesando la historia clínica:", error);
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;

      const sessionExpired =
        status === 401 ||
        status === 403 ||
        detail === "Authentication credentials were not provided." ||
        detail === "CSRF Failed: CSRF token missing or incorrect.";

      if (sessionExpired) {
        // 🟦 Guardamos el borrador (historia + paciente_id ya lo tienes arriba)
        // Ya está guardado ANTES del POST. No volver a guardarlo aquí.

        try {
          // 🟦 Guardar la URL actual para volver EXACTO al mismo punto
          localStorage.setItem(
            "salvir_redirect_after_login",
            window.location.href
          );
        } catch (e) {
          console.error("❌ No se pudo guardar la URL de retorno:", e);
        }

        // 🟦 Redirigir al login
        window.location.href = "/login";
        return;
      }
      if (error.response) {
          console.error("📌 Respuesta del servidor:", error.response.data);
          //QUITAMOS EL ALERT PARA CONSOLIDARLO EN
          //alert(`Error en la creación: ${JSON.stringify(error.response.data)}`);
      }
  }
  setLoadingSubmit(false);
};

const handleOpenConfirm = (e) => {
  e.preventDefault();
  
   if (!historia?.fechaConsulta) {
    toast.error("La fecha y hora de la consulta es obligatoria.");
    setIsFechaEditable(true);
    return;
  }

  if (!validarFechaConsultaNoFuturo(historia.fechaConsulta)) {
    msgFechaConsultaFuturo();
    setIsFechaEditable(true);
    return;
  }

  if (
    !validarFechaConsultaNoAntesNacimiento(
      historia.fechaConsulta,
      paciente?.fecha_nacimiento
    )
  ) {
    msgFechaConsultaAntesNacimiento();
    setIsFechaEditable(true);
    return;
  }
  
  // Validación bloqueante de edad máxima del paciente.
  // Compara su fecha de nacimiento contra la fecha de consulta.
  // El paciente puede tener hasta 120 años; desde 121 se bloquea.
  if (
    perfil?.nom024 &&
    !pacienteTieneEdadPermitida(
      paciente?.fecha_nacimiento,
      historia?.fechaConsulta
    )
  ) {
    setTipoEdadBloqueante("paciente");
    return;
  }

  // Validación bloqueante de edad máxima del prestador.
  // Compara la fecha de nacimiento del médico contra la fecha de consulta.
  // El prestador puede tener hasta 90 años; desde 91 se bloquea.
  if (
    perfil?.nom024 &&
    !prestadorTieneEdadPermitida(
      medico?.fecha_nacimiento,
      historia?.fechaConsulta
    )
  ) {
    setTipoEdadBloqueante("prestador");
    return;
  }

  if (perfil?.nom024) {
    const faltantes = obtenerFaltantesHistoriaNOM024(historia,aplicaUneme,diagnosticosSeleccionados,
      calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, historia?.fechaConsulta)
    );
    if (faltantes.length > 0) {
      setFaltantesConsulta(faltantes);
      setShowConsultaIncompleta(true);
      return;
    }
  }

  setShowConfirm(true);
};

 // ⬇️⬇️⬇️ Pega aquí el useEffect del IMC, en top-level (no dentro de ningún if)
  useEffect(() => {
  const pesoRaw = historia.exploracionFisica?.peso;
  const alturaRaw = historia.exploracionFisica?.altura;

  // Si peso o talla son 999 (desconocido), no calcular IMC
  if (String(pesoRaw) === "999" || String(alturaRaw) === "999") {
    setHistoria(hst => ({ ...hst, imc: "", categoria_imc: "" }));
    return;
  }

  const peso = parseFloat(pesoRaw);
  const altura = parseFloat(alturaRaw);

  if (!isNaN(peso) && peso > 0 && !isNaN(altura) && altura > 0) {
    const h = altura < 10 ? altura : altura / 100;
    const imcNum = +(peso / (h * h)).toFixed(2);

    let cat = "";
    if (imcNum < 18.5) cat = "Bajo peso";
    else if (imcNum < 25) cat = "Peso normal";
    else if (imcNum < 30) cat = "Sobrepeso";
    else if (imcNum < 35) cat = "Obesidad grado I";
    else if (imcNum < 40) cat = "Obesidad grado II";
    else cat = "Obesidad grado III";

    setHistoria(hst => ({ ...hst, imc: String(imcNum), categoria_imc: cat }));
  } else {
    setHistoria(hst => ({ ...hst, imc: "", categoria_imc: "" }));
  }
}, [historia.exploracionFisica?.peso, historia.exploracionFisica?.altura]);

  if (isLoading) {
    return <div>Cargando datos del paciente...</div>;
  }

  // Cambio de etiquetas sin impactar backend

  const etiquetasPersonalesPatologicos = {
    ECD: "Enfermedades Crónico Degenerativas",
    quirurgicos: "Quirúrgicos",
    traumaticos: "Traumáticos",
    exantematicos: "Exantemáticos",
    vacunacion: "Vacunación",
    ginecoObstetricosAndrologicos: "Gineco-obstétricos / Andrológicos"
  };

  const etiquetasPersonalesNoPatologicos = {
    ocupacion: "Ocupación",
    religion: "Religión",
    alimentacion: "Alimentación"
  };

 

  return (
    <div className="alta-historia-clinica-form">
      <h2>Captura de historia clínica y consulta inicial</h2>      
      {/* --- Barra sticky (chips) de rubros --- */}
        <div className="tabs-container">
          <div className="paciente-header" ref={pacienteHeaderRef}>
            <h3 className="paciente-title">
              Paciente: {paciente?.nombre_completo}
            </h3>

            <button
              type="button"
              className={`paciente-toggle ${showPacienteInfo ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setShowPacienteInfo((v) => !v);
              }}
              aria-label="Ver datos del paciente"
              aria-expanded={showPacienteInfo}
            >
            ▼
            </button>

            {showPacienteInfo && (
              <div
                className="paciente-popover"
                onMouseDown={(e) => e.stopPropagation()}
              >
                <div><strong>Edad:</strong> {paciente?.edad || "—"}</div>
                <div><strong>Sexo:</strong> {paciente?.sexo || "—"}</div>
                {historia?.padecimientoActual ? (
                  <div><strong>Motivo:</strong> {historia.padecimientoActual}</div>
                ) : null}
              </div>
            )}
          </div>

          <div className="tabs-scroll">
            <button
              type="button"
              className="tab"
              onClick={handleToggleAll}
              title={allOpen ? "Contraer todo" : "Expandir todo"}
            >
              {allOpen ? "Contraer todo" : "Expandir todo"}
            </button>

            {RUBROS.map((r) => (
              <button
                key={r.id}
                type="button"
                className="tab"
                onClick={() => scrollToAnchor(r.id)}
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>

      <form onSubmit={handleOpenConfirm}>
        <div className="aviso-normatividad">
          
          <p>La información registrada en <strong>antecedentes</strong> puede ser actualizada posteriormente. 
          El resto de los apartados forman parte del expediente clínico y, conforme a normatividad, no 
          pueden modificarse una vez registrados; únicamente es posible añadir indicaciones adicionales.</p>
           {perfil?.nom024 && (
            <p><strong>Los campos con * son obligatorios</strong></p>
            )}
        </div>

        <HistoriaClinicaFormCommon
                  historia={historia}
                  setHistoria={setHistoria}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  openRubros={openRubros}
                  toggleRubro={toggleRubro}
                  isFechaEditable={isFechaEditable}
                  toggleFechaEditable={toggleFechaEditable}
                  handleChange={handleChange}
                  handleNestedChange={handleNestedChange}
                  handleDeepNestedChange={handleDeepNestedChange}
                  etiquetasPersonalesPatologicos={etiquetasPersonalesPatologicos}
                  etiquetasPersonalesNoPatologicos={etiquetasPersonalesNoPatologicos}
                  showGrupoEtnicoOtro={showGrupoEtnicoOtro}
                  setShowGrupoEtnicoOtro={setShowGrupoEtnicoOtro}
                  cuestionarioConfig={cuestionarioConfig}
                  plantillasHabilitadas={perfil?.plantillas_habilitadas ?? false}
                  plantillasPersonalizadas={Array.isArray(perfil?.plantillas_personalizadas)
                      ? perfil.plantillas_personalizadas
                      : []
                  }
                  sugerenciasHistoricasHabilitadas={
                    perfil?.sugerencias_historicas_habilitadas ?? true
                  }
                  onOcultarSugerenciaHistorica={handleOcultarSugerenciaHistorica}
                  edadPaciente={calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, historia?.fechaConsulta)}
                  edadMesesPaciente={calcularEdadMesesEnFechaConsulta(paciente?.fecha_nacimiento, historia?.fechaConsulta)}
                  nom024={perfil?.nom024 ?? false}
                  sexo={paciente?.sexo}
                  fechaNacimiento={paciente?.fecha_nacimiento}
                  fechaNacimientoPrestador={medico?.fecha_nacimiento}
                  pacienteId={pacienteId}
                  serviciosAtencion={serviciosAtencion}
                  aplicaUneme={aplicaUneme}
                  diagnosticosSeleccionados={diagnosticosSeleccionados}
                  setDiagnosticosSeleccionados={setDiagnosticosSeleccionados}
                />
        
        

        {/*<div className="rubro">
           Próxima cita 
          <h3>Próxima Cita</h3>
          <input
            type="date"
            name="proximaCita"
            value={historia.proximaCita}
            onChange={handleChange}
          />
        </div>*/}

        {/* Botón de Enviar */}
        <button type="submit" disabled={loadingSubmit}>
          {loadingSubmit
            ? "Guardando…"
            : paciente && paciente.historiaClinicaId
              ? "Actualizar Historia Clínica"
              : "Registrar Historia Clínica"}
        </button>
      </form>
      {showConsultaIncompleta && (
        <ModalConsultaIncompleta
          faltantes={faltantesConsulta}
          tipo="historia"
          onClose={() => {
            setShowConsultaIncompleta(false);
            setFaltantesConsulta([]);
          }}
        />
      )}
       {/* 
        Se utiliza una sola instancia del modal para ambas validaciones.
        tipoEdadBloqueante determina si debe mostrar al paciente
        o al prestador y qué fecha de nacimiento debe evaluar.
      */}
      {tipoEdadBloqueante && (
        <ModalEdadPaciente
          modo="bloqueante"
          tipoPersona={tipoEdadBloqueante}
          fechaNacimiento={
            tipoEdadBloqueante === "prestador"
              ? medico?.fecha_nacimiento
              : paciente?.fecha_nacimiento
          }
          fechaConsulta={historia?.fechaConsulta}
          onClose={() => setTipoEdadBloqueante(null)}
        />
      )}
      <ModalConfirmacion
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false);
          handleSubmit(); // llama tu guardado real
        }}
        tipo="historia"
      />
     {perfil?.nom024 && faltantes?.length > 0 && (
  <ModalPerfilIncompleto faltantes={faltantes} />
)}

{perfil?.nom024 &&
  (!faltantes || faltantes.length === 0) &&
  obtenerFaltantesPacienteNOM024(paciente, medico?.curpPrestador)?.length > 0 && (
    <ModalPacienteIncompleto
      faltantes={obtenerFaltantesPacienteNOM024(paciente, medico?.curpPrestador)}
      pacienteId={pacienteId}
    />
)}
    </div>
  );
};

export default AltaHistoriaClinica;